module.exports = __webpack_public_path__ + "img/IMG_1867_FoamcoreMatted.3413315b.jpg";